<!-- <div class="row regulatory_row mt-1">
  <app-progress-bar [isLoading]="isLoadingFilters"></app-progress-bar>
  <div class="col-md-3 col-lg-3">
    <div class="form-group">
      <div class="left inline control-label mb-1">Date From</div>
      <div class="input-group input-group-sm">
        <input matInput [matDatepicker]="picker" (click)="picker.open()" placeholder="Choose a date"
          class="form-control form-control-sm border-bottom" id="fromDate" placeholder="From"
          [(ngModel)]="selfAssessmentFilter.fromDate" readonly>
        <div class="input-group-append">
          <span class="input-group-text fa fa-calendar" (click)="picker.open()"></span>
        </div>
      </div>
      <mat-datepicker #picker></mat-datepicker>
    </div>
  </div>

  <div class="col-md-3 col-lg-3">
    <div class="form-group">
      <div class="left inline control-label d-none d-sm-block mb-1">Date Until</div>
      <div class="input-group input-group-sm">
        <input matInput [matDatepicker]="toPicker" (click)="toPicker.open()" placeholder="Choose a date"
          class="form-control form-control-sm border-bottom" id="toDate" placeholder="From" [(ngModel)]="selfAssessmentFilter.toDate"
          readonly>
        <div class="input-group-append">
          <span class="input-group-text fa fa-calendar" (click)="toPicker.open()"></span>
        </div>
      </div>
      <mat-datepicker #toPicker></mat-datepicker>
    </div>
  </div>
  <div class="col-md-2 col-lg-2">
    <div class="form-group">
      <div class="left inline control-label mb-1">Legal Entity</div>
      <mat-chip-grid #lEList>
        <mat-chip-row *ngFor="let objItem of selfAssessmentFilter.legalEntity" [selectable]="selectable"
          [removable]="removable" (removed)="removeLE(objItem)">
          {{objItem}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip-row>
        <input class="form-control form-control-sm mat-autodd-input border-bottom" #lEInput [formControl]="searchLECntrl"
          [matAutocomplete]="lEAutocomplete" [matChipInputFor]="lEList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
          (matChipInputTokenEnd)="addLE($event)">
      </mat-chip-grid>
      <mat-autocomplete #lEAutocomplete="matAutocomplete" (optionSelected)="selectedLEEvent($event)">
        <mat-option *ngFor="let obj of searchedLE" [value]="obj.value">
          {{obj.name}}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
  <div class="col-md-2 col-lg-2">
    <div class="form-group">
      <div class="left inline control-label mb-1">Action Team</div>
      <mat-chip-grid #actTList>
        <mat-chip-row *ngFor="let objItem of selfAssessmentFilter.actionTeam" [selectable]="selectable"
          [removable]="removable" (removed)="removeActT(objItem)">
          {{objItem}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip-row>
        <input class="form-control form-control-sm mat-autodd-input border-bottom" #actTInput [formControl]="searchActTCntrl"
          [matAutocomplete]="actTAutocomplete" [matChipInputFor]="actTList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
          (matChipInputTokenEnd)="addActT($event)">
      </mat-chip-grid>
      <mat-autocomplete #actTAutocomplete="matAutocomplete" (optionSelected)="selectedActTEvent($event)">
        <mat-option *ngFor="let obj of searchedActT" [value]="obj.value">
          {{obj.name}}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
  <div class="col-md-2 col-lg-2">
    <div class="form-group">
      <div class="left inline control-label mb-1">Review Team</div>
      <mat-chip-grid #rTList>
        <mat-chip-row *ngFor="let objItem of selfAssessmentFilter.reviewTeam" [selectable]="selectable"
          [removable]="removable" (removed)="removeRT(objItem)">
          {{objItem}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip-row>
        <input class="form-control form-control-sm mat-autodd-input border-bottom" #rTInput [formControl]="searchRTCntrl"
          [matAutocomplete]="rTAutocomplete" [matChipInputFor]="rTList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
          (matChipInputTokenEnd)="addRT($event)">
      </mat-chip-grid>
      <mat-autocomplete #rTAutocomplete="matAutocomplete" (optionSelected)="selectedRTEvent($event)">
        <mat-option *ngFor="let obj of searchedRT" [value]="obj.value">
          {{obj.name}}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
</div>
<div class="row regulatory_row mt-1">
  <div class="col-md-3 col-lg-3">
    <div class="form-group">
      <div class="left inline control-label mb-1">Assessment Team</div>
      <mat-chip-grid #aTList>
        <mat-chip-row *ngFor="let objItem of selfAssessmentFilter.assessmentTeam" [selectable]="selectable"
          [removable]="removable" (removed)="removeAT(objItem)">
          {{objItem}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip-row>
        <input class="form-control form-control-sm mat-autodd-input border-bottom" #aTInput [formControl]="searchATCntrl"
          [matAutocomplete]="aTAutocomplete" [matChipInputFor]="aTList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
          (matChipInputTokenEnd)="addAT($event)">
      </mat-chip-grid>
      <mat-autocomplete #aTAutocomplete="matAutocomplete" (optionSelected)="selectedATEvent($event)">
        <mat-option *ngFor="let obj of searchedAT" [value]="obj.value">
          {{obj.name}}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
  <div class="col-md-3 col-lg-3">
    <div class="form-group">
      <div class="left inline control-label mb-1">Assessment Status</div>
      <mat-chip-grid #aSList>
        <mat-chip-row *ngFor="let objItem of selfAssessmentFilter.assessmentStatus" [selectable]="selectable"
          [removable]="removable" (removed)="removeAS(objItem)">
          {{objItem}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip-row>
        <input class="form-control form-control-sm mat-autodd-input border-bottom" #aSInput [formControl]="searchASCntrl"
          [matAutocomplete]="aSAutocomplete" [matChipInputFor]="aSList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
          (matChipInputTokenEnd)="addAS($event)">
      </mat-chip-grid>
      <mat-autocomplete #aSAutocomplete="matAutocomplete" (optionSelected)="selectedASEvent($event)">
        <mat-option *ngFor="let obj of searchedAS" [value]="obj.value">
          {{obj.name}}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
  <div class="col-md-2 col-lg-2">
    <div class="form-group">
      <div class="left inline control-label mb-1">Review Status</div>
      <mat-chip-grid #rSList>
        <mat-chip-row *ngFor="let objItem of selfAssessmentFilter.reviewStatus" [selectable]="selectable"
          [removable]="removable" (removed)="removeRS(objItem)">
          {{objItem}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip-row>
        <input class="form-control form-control-sm mat-autodd-input border-bottom" #rSInput [formControl]="searchRSCntrl"
          [matAutocomplete]="rSAutocomplete" [matChipInputFor]="rSList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
          (matChipInputTokenEnd)="addRS($event)">
      </mat-chip-grid>
      <mat-autocomplete #rSAutocomplete="matAutocomplete" (optionSelected)="selectedRSEvent($event)">
        <mat-option *ngFor="let obj of searchedRS" [value]="obj.value">
          {{obj.name}}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
  <div class="col-md-2 col-lg-2">
    <div class="form-group">
      <div class="left inline control-label mb-1">Action Status</div>
      <mat-chip-grid #actSList>
        <mat-chip-row *ngFor="let objItem of selfAssessmentFilter.actionStatus" [selectable]="selectable"
          [removable]="removable" (removed)="removeActS(objItem)">
          {{objItem}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip-row>
        <input class="form-control form-control-sm mat-autodd-input border-bottom" #actSInput [formControl]="searchActSCntrl"
          [matAutocomplete]="actSAutocomplete" [matChipInputFor]="actSList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
          (matChipInputTokenEnd)="addActS($event)">
      </mat-chip-grid>
      <mat-autocomplete #actSAutocomplete="matAutocomplete" (optionSelected)="selectedActSEvent($event)">
        <mat-option *ngFor="let obj of searchedActS" [value]="obj.value">
          {{obj.name}}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
  <div class="col-md-2 col-lg-2">
    <div class="form-group">
      <div class="left inline control-label mb-1">Rule Conclusion</div>
      <mat-chip-grid #rCList>
        <mat-chip-row *ngFor="let objItem of selfAssessmentFilter.ruleConclusion" [selectable]="selectable"
          [removable]="removable" (removed)="removeRC(objItem)">
          {{objItem}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip-row>
        <input class="form-control form-control-sm mat-autodd-input border-bottom" #rCInput [formControl]="searchRCCntrl"
          [matAutocomplete]="rCAutocomplete" [matChipInputFor]="rCList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
          (matChipInputTokenEnd)="addRC($event)">
      </mat-chip-grid>
      <mat-autocomplete #rCAutocomplete="matAutocomplete" (optionSelected)="selectedRCEvent($event)">
        <mat-option *ngFor="let obj of searchedRC" [value]="obj.value">
          {{obj.name}}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
</div>
<div class="row regulatory_row mt-1">
  <div class="col-md-3 col-lg-3">
    <div class="form-group">
      <div class="left inline control-label mb-1">Overall Rule Status</div>
      <mat-chip-grid #oRSList>
        <mat-chip-row *ngFor="let objItem of selfAssessmentFilter.overallRuleStatus" [selectable]="selectable"
          [removable]="removable" (removed)="removeORS(objItem)">
          {{objItem}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip-row>
        <input class="form-control form-control-sm mat-autodd-input border-bottom" #oRSInput [formControl]="searchORSCntrl"
          [matAutocomplete]="oRSAutocomplete" [matChipInputFor]="oRSList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
          (matChipInputTokenEnd)="addORS($event)">
      </mat-chip-grid>
      <mat-autocomplete #oRSAutocomplete="matAutocomplete" (optionSelected)="selectedORSEvent($event)">
        <mat-option *ngFor="let obj of searchedORS" [value]="obj.value">
          {{obj.name}}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
  <div class="col-md-3 col-lg-3">
    <div class="form-group">
      <div class="left inline control-label mb-1">Gap Review Status</div>
      <mat-chip-grid #gRSList>
        <mat-chip-row *ngFor="let objItem of selfAssessmentFilter.gapReviewStatus" [selectable]="selectable"
          [removable]="removable" (removed)="removeGRS(objItem)">
          {{objItem}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip-row>
        <input class="form-control form-control-sm mat-autodd-input border-bottom" #gRSInput [formControl]="searchGRSCntrl"
          [matAutocomplete]="gRSAutocomplete" [matChipInputFor]="gRSList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
          (matChipInputTokenEnd)="addGRS($event)">
      </mat-chip-grid>
      <mat-autocomplete #gRSAutocomplete="matAutocomplete" (optionSelected)="selectedGRSEvent($event)">
        <mat-option *ngFor="let obj of searchedGRS" [value]="obj.value">
          {{obj.name}}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
  <div class="col-md-2 col-lg-2">
    <div class="form-group">
      <div class="left inline control-label mb-1">Key Words</div>
      <mat-chip-grid #keywordsList>
        <mat-chip-row *ngFor="let sQuery of selfAssessmentFilter.searchQuery" [selectable]="selectable"
          [removable]="removable" (removed)="remove(sQuery)">
          {{sQuery}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip-row>
        <input class="form-control form-control-sm mat-autodd-input border-bottom" #keywordInput [formControl]="keyCtrl"
          [matAutocomplete]="autoKeyword" [matChipInputFor]="keywordsList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
          (matChipInputTokenEnd)="add($event)">
      </mat-chip-grid>
      <mat-autocomplete #autoKeyword="matAutocomplete" (optionSelected)="selected($event)">
        <mat-option *ngFor="let fK of filteredKeywords" [value]="fK">
          {{fK}}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
  <div class="col-md-3 col-lg-3 pt-4">
    <div class="form-group">
      <span class="ml-2 btn btn-sm pl-1" (click)="initFilters()">Reset</span>
      <button type="button" class="btn btn-sm bg-purple text-white ml-2 btn-blue text-white" id="btn-search"
        (click)="TriggerAction()">Submit</button>
    </div>
  </div>
</div> -->

<div class="selfscroll_body">
  <div class="row ml-2 mt-1 mx-1">
    <div class="col-md-4 col-lg-4">
      <div class="form-group">
        <div class="left inline control-label mb-1">Assessment Date From</div>
        <div class="input-group input-group-sm">
          <input matInput [matDatepicker]="picker" (click)="picker.open()" placeholder="Choose a date"
            class="form-control form-control-sm border-bottom" id="fromDate" placeholder="From"
            [(ngModel)]="selfAssessmentFilter.fromDate" readonly>
          <div class="input-group-append">
            <span class="input-group-text fa fa-calendar" (click)="picker.open()"></span>
          </div>
        </div>
        <mat-datepicker #picker></mat-datepicker>
      </div>
    </div>
  
    <div class="col-md-4 col-lg-4">
      <div class="form-group">
        <div class="left inline control-label d-none d-sm-block mb-1">Assessment Date To</div>
        <div class="input-group input-group-sm">
          <input matInput [matDatepicker]="toPicker" (click)="toPicker.open()" placeholder="Choose a date"
            class="form-control form-control-sm border-bottom" id="toDate" placeholder="To" [(ngModel)]="selfAssessmentFilter.toDate"
            readonly>
          <div class="input-group-append">
            <span class="input-group-text fa fa-calendar" (click)="toPicker.open()"></span>
          </div>
        </div>
        <mat-datepicker #toPicker></mat-datepicker>
      </div>
    </div>
    <div class="col-md-4 col-lg-4">
      <div class="form-group">
        <div class="left inline control-label mb-1">Key Words</div>
        <mat-chip-grid #keywordsList>
          <mat-chip-row *ngFor="let sQuery of selfAssessmentFilter.searchQuery" [selectable]="selectable"
            [removable]="removable" (removed)="remove(sQuery)">
            {{sQuery}}
            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
          </mat-chip-row>
          <input class="form-control form-control-sm mat-autodd-input border-bottom" #keywordInput [formControl]="keyCtrl"
            [matAutocomplete]="autoKeyword" [matChipInputFor]="keywordsList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="add($event)">
        </mat-chip-grid>
        <mat-autocomplete #autoKeyword="matAutocomplete" (optionSelected)="selected($event)">
          <mat-option *ngFor="let fK of filteredKeywords" [value]="fK">
            {{fK}}
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>
  </div>
  
  <div class="row mt-1 mb-1 mx-1">
    <div class="col-12 accordions">
      <mat-accordion id="RulebookSection" class="mt-1">
        <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
          <mat-expansion-panel-header class="ia-mat-panel">
            <mat-panel-title>
              <span class="text-header inc-f">
                Search Rulebook Section
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row ml-2 mt-1">
            <div class="col-md-3 col-lg-3">
              <div class="form-group">
                <div class="left inline control-label mb-1">Rulebook</div>
                <mat-chip-grid #rulebookList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentFilter.ruleBook" [selectable]="selectable"
                    [removable]="removable" (removed)="removeRB(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm border-bottom" #rBInput autocomplete="off" [matChipInputFor]="rulebookList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="addRB($event)">
                </mat-chip-grid>
              </div>
            </div>
            <div class="col-md-3 col-lg-3">
              <div class="form-group">
                <div class="left inline control-label mb-1">Part</div>
                <mat-chip-grid #partList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentFilter.part" [selectable]="selectable"
                    [removable]="removable" (removed)="removePA(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm border-bottom" #pAInput autocomplete="off" [matChipInputFor]="partList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="addPA($event)">
                </mat-chip-grid>
              </div>
            </div>
            <div class="col-md-3 col-lg-3">
              <div class="form-group">
                <div class="left inline control-label mb-1">Owner</div>
                <mat-chip-grid #ownerList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentFilter.owner" [selectable]="selectable"
                    [removable]="removable" (removed)="removeOW(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom" #oWInput [formControl]="searchOWCntrl"
                    [matAutocomplete]="oWAutocomplete" [matChipInputFor]="ownerList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="addOW($event)">
                </mat-chip-grid>
                <mat-autocomplete #oWAutocomplete="matAutocomplete" (optionSelected)="selectedOWEvent($event)">
                  <mat-option *ngFor="let fK of searchedOwner" [value]="fK.value" [title]="fK.name">
                    {{fK.name}}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
            <div class="col-md-3 col-lg-3">
              <div class="form-group">
                <div class="left inline control-label mb-1">Rule Text</div>
                <mat-chip-grid #ruletextList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentFilter.regulatoryRuleFullRequirement" [selectable]="selectable"
                    [removable]="removable" (removed)="removeRR(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm border-bottom" #rRInput autocomplete="off" [matChipInputFor]="ruletextList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="addRR($event)">
                </mat-chip-grid>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <mat-accordion id="AssessmentSection" class="mt-1">
        <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
          <mat-expansion-panel-header class="ia-mat-panel">
            <mat-panel-title>
              <span class="text-header inc-f">
                Search Assessment Section
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row ml-2 mt-1">
            <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <div class="left inline control-label mb-1">Assessment Team</div>
                <mat-chip-grid #assessmentTeamList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentFilter.assessmentTeam" [selectable]="selectable"
                    [removable]="removable" (removed)="removeAT(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom" #aTInput [formControl]="searchATCntrl"
                    [matAutocomplete]="aTAutocomplete" [matChipInputFor]="assessmentTeamList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="addAT($event)">
                </mat-chip-grid>
                <mat-autocomplete #aTAutocomplete="matAutocomplete" (optionSelected)="selectedATEvent($event)">
                  <mat-option *ngFor="let fK of searchedAT" [value]="fK.value" [title]="fK.name">
                    {{fK.name}}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
            <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <div class="left inline control-label mb-1">Assessment Details</div>
                <mat-chip-grid #assessmentDetailList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentFilter.assessmentDetails" [selectable]="selectable"
                    [removable]="removable" (removed)="removeAD(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm border-bottom" #aDInput autocomplete="off" [matChipInputFor]="assessmentDetailList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="addAD($event)">
                </mat-chip-grid>
              </div>
            </div>
            <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <div class="left inline control-label mb-1">Assessment Status</div>
                <mat-chip-grid #assessmentStatusList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentFilter.assessmentStatus" [selectable]="selectable"
                    [removable]="removable" (removed)="removeAS(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom" #aSInput [formControl]="searchASCntrl"
                    [matAutocomplete]="aSAutocomplete" [matChipInputFor]="assessmentStatusList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="addAS($event)">
                </mat-chip-grid>
                <mat-autocomplete #aSAutocomplete="matAutocomplete" (optionSelected)="selectedASEvent($event)">
                  <mat-option *ngFor="let fK of searchedAS" [value]="fK.value" [title]="fK.name">
                    {{fK.name}}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <mat-accordion id="ReviewSection" class="mt-1">
        <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
          <mat-expansion-panel-header class="ia-mat-panel">
            <mat-panel-title>
              <span class="text-header inc-f">
                Search Review Section
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row ml-2 mt-1">
            <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <div class="left inline control-label mb-1">Review Team</div>
                <mat-chip-grid #reviewTeamList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentFilter.reviewTeam" [selectable]="selectable"
                    [removable]="removable" (removed)="removeRT(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom" #rTInput [formControl]="searchRTCntrl"
                    [matAutocomplete]="rTAutocomplete" [matChipInputFor]="reviewTeamList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="addRT($event)">
                </mat-chip-grid>
                <mat-autocomplete #rTAutocomplete="matAutocomplete" (optionSelected)="selectedRTEvent($event)">
                  <mat-option *ngFor="let fK of searchedRT" [value]="fK.value" [title]="fK.name">
                    {{fK.name}}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
            <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <div class="left inline control-label mb-1">Review Details</div>
                <mat-chip-grid #reviewDetailsList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentFilter.reviewDetails" [selectable]="selectable"
                    [removable]="removable" (removed)="removeRD(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm border-bottom" #rDInput autocomplete="off" [matChipInputFor]="reviewDetailsList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="addRD($event)">
                </mat-chip-grid>
              </div>
            </div>
            <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <div class="left inline control-label mb-1">Review Status</div>
                <mat-chip-grid #reviewStatusList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentFilter.reviewStatus" [selectable]="selectable"
                    [removable]="removable" (removed)="removeRS(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom" #rSInput [formControl]="searchRSCntrl"
                    [matAutocomplete]="rSAutocomplete" [matChipInputFor]="reviewStatusList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="addRS($event)">
                </mat-chip-grid>
                <mat-autocomplete #rSAutocomplete="matAutocomplete" (optionSelected)="selectedRSEvent($event)">
                  <mat-option *ngFor="let fK of searchedRS" [value]="fK.value" [title]="fK.name">
                    {{fK.name}}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <mat-accordion id="OverallSection" class="mt-1">
        <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
          <mat-expansion-panel-header class="ia-mat-panel">
            <mat-panel-title>
              <span class="text-header inc-f">
                Search Overall Section
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row ml-2 mt-1">
            <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <div class="left inline control-label mb-1">Overall Status</div>
                <mat-chip-grid #overallStatusList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentFilter.overallStatus" [selectable]="selectable"
                    [removable]="removable" (removed)="removeOS(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom" #oSInput [formControl]="searchOSCntrl"
                    [matAutocomplete]="oSAutocomplete" [matChipInputFor]="overallStatusList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="addOS($event)">
                </mat-chip-grid>
                <mat-autocomplete #oSAutocomplete="matAutocomplete" (optionSelected)="selectedOSEvent($event)">
                  <mat-option *ngFor="let fK of searchedOS" [value]="fK.value" [title]="fK.name">
                    {{fK.name}}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
            <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <div class="left inline control-label mb-1">Rule Conclusion</div>
                <mat-chip-grid #ruleConclusionList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentFilter.ruleConclusion" [selectable]="selectable"
                    [removable]="removable" (removed)="removeRC(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom" #rCInput [formControl]="searchRCCntrl"
                    [matAutocomplete]="rCAutocomplete" [matChipInputFor]="ruleConclusionList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="addRC($event)">
                </mat-chip-grid>
                <mat-autocomplete #rCAutocomplete="matAutocomplete" (optionSelected)="selectedRCEvent($event)">
                  <mat-option *ngFor="let fK of searchedRC" [value]="fK.value" [title]="fK.name">
                    {{fK.name}}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
            <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <div class="left inline control-label mb-1">Overall Conclusion</div>
                <mat-chip-grid #overallConclusionList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentFilter.overallConclusion" [selectable]="selectable"
                    [removable]="removable" (removed)="removeOC(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm border-bottom" #oCInput autocomplete="off" [matChipInputFor]="overallConclusionList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="addOC($event)">
                </mat-chip-grid>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <mat-accordion id="Gap Section" class="mt-1">
        <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
          <mat-expansion-panel-header class="ia-mat-panel">
            <mat-panel-title>
              <span class="text-header inc-f">
                Search Gap Section
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row ml-2 mt-1">
            <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <div class="left inline control-label mb-1">Gap Team</div>
                <mat-chip-grid #gapTeamList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentFilter.gapTeam" [selectable]="selectable"
                    [removable]="removable" (removed)="removeGT(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom" #gTInput [formControl]="searchGTCntrl"
                    [matAutocomplete]="gTAutocomplete" [matChipInputFor]="gapTeamList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="addGT($event)">
                </mat-chip-grid>
                <mat-autocomplete #gTAutocomplete="matAutocomplete" (optionSelected)="selectedGTEvent($event)">
                  <mat-option *ngFor="let fK of searchedGT" [value]="fK.value" [title]="fK.name">
                    {{fK.name}}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
            <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <div class="left inline control-label mb-1">Gap Details</div>
                <mat-chip-grid #gapDetailsList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentFilter.gapDetails" [selectable]="selectable"
                    [removable]="removable" (removed)="removeGD(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm border-bottom" #gDInput autocomplete="off" [matChipInputFor]="gapDetailsList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="addGD($event)">
                </mat-chip-grid>
              </div>
            </div>
            <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <div class="left inline control-label mb-1">Gap Status</div>
                <mat-chip-grid #gapStatusList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentFilter.gapStatus" [selectable]="selectable"
                    [removable]="removable" (removed)="removeGS(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom" #gSInput [formControl]="searchGSCntrl"
                    [matAutocomplete]="gSAutocomplete" [matChipInputFor]="gapStatusList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="addGS($event)">
                </mat-chip-grid>
                <mat-autocomplete #gSAutocomplete="matAutocomplete" (optionSelected)="selectedGSEvent($event)">
                  <mat-option *ngFor="let fK of searchedGS" [value]="fK.value" [title]="fK.name">
                    {{fK.name}}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <mat-accordion id="EnhancementSection" class="mt-1">
        <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
          <mat-expansion-panel-header class="ia-mat-panel">
            <mat-panel-title>
              <span class="text-header inc-f">
                Search Enhancement Section
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row ml-2 mt-1">
            <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <div class="left inline control-label mb-1">Enhancement Team</div>
                <mat-chip-grid #enchancementTeamList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentFilter.enhancementTeam" [selectable]="selectable"
                    [removable]="removable" (removed)="removeET(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom" #eTInput [formControl]="searchETCntrl"
                    [matAutocomplete]="eTAutocomplete" [matChipInputFor]="enchancementTeamList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="addET($event)">
                </mat-chip-grid>
                <mat-autocomplete #eTAutocomplete="matAutocomplete" (optionSelected)="selectedETEvent($event)">
                  <mat-option *ngFor="let fK of searchedET" [value]="fK.value" [title]="fK.name">
                    {{fK.name}}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
            <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <div class="left inline control-label mb-1">Enhancement Details</div>
                <mat-chip-grid #enhancementDetailList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentFilter.enhancementDetails" [selectable]="selectable"
                    [removable]="removable" (removed)="removeED(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm border-bottom" #eDInput
                  autocomplete="off" [matChipInputFor]="enhancementDetailList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="addED($event)">
                </mat-chip-grid>
              </div>
            </div>
            <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <div class="left inline control-label mb-1">Enhancement Status</div>
                <mat-chip-grid #enhancementStatusList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentFilter.enhancementStatus" [selectable]="selectable"
                    [removable]="removable" (removed)="removeES(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom" #eSInput [formControl]="searchESCntrl"
                    [matAutocomplete]="eSAutocomplete" [matChipInputFor]="enhancementStatusList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="addES($event)">
                </mat-chip-grid>
                <mat-autocomplete #eSAutocomplete="matAutocomplete" (optionSelected)="selectedESEvent($event)">
                  <mat-option *ngFor="let fK of searchedES" [value]="fK.value" [title]="fK.name">
                    {{fK.name}}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>

<div class="row regulatory_row mx-1 mt-1">
  <div class="col-12 pt-2">
    <div class="form-group mb-0 text-right">
      <span class="ml-2 btn btn-sm pl-1" (click)="resetFilters()">Reset</span>
      <button type="button" class="btn btn-sm bg-purple text-white ml-2 btn-blue text-white" id="btn-search"
        (click)="TriggerAction()">Submit</button>
    </div>
  </div>
</div>
